import { useSearchParams } from "react-router-dom";

export const PLANNER_ROLES = ["manager", "office", "super_admin"];
export const hasPro = (user) => user?.role === "super_admin" || user?.pro_package === true;
export const canPlan = (user) => hasPro(user) && PLANNER_ROLES.includes(user?.role);
export const isProRequired = (e) => e?.response?.status === 403 && e?.response?.data?.detail?.code === "PRO_PACKAGE_REQUIRED";

export const STATUS_COLORS = { planned: "#3D6080", in_progress: "#F5A623", done: "#22A06B" };

// Super admins work company by company: every /api/pro call carries ?company_id=.
export function useProScope(user) {
  const [sp, setSp] = useSearchParams();
  const isSA = user?.role === "super_admin";
  const cid = sp.get("company_id") || "";
  return {
    isSA,
    cid,
    params: isSA ? { company_id: cid } : {},
    needsCompany: isSA && !cid,
    suffix: isSA && cid ? `?company_id=${encodeURIComponent(cid)}` : "",
    setCompany: (id) => setSp(id ? { company_id: id } : {}),
  };
}
